<div class="p-4 w-[400px]">
  <h1 i18n>確定要儲存嗎？</h1>

  <p i18n class="mt-4 text-sm">此動作會覆蓋原本訊息，請確認是否要儲存</p>
  <div class="flex justify-between mt-5 p-1">
    <button type="button" mat-button color="primary" (click)="cancel()" i18n>
      取消
    </button>
    <div class="flex gap-2">
      <button
        type="button"
        mat-button
        color="primary"
        (click)="saveAsNew()"
        i18n
      >
        另存為新訊息
      </button>
      <button mat-raised-button color="primary" (click)="submit()" i18n>
        確定
      </button>
    </div>
  </div>
</div>
